import * as R from 'ramda'

export const checkActiveModule = module =>
  R.and(!R.isNil(module), R.equals(module, R.T()))
